import { ArrowLongDownIcon, CheckCircleIcon } from "@heroicons/react/16/solid";
import clsx from "clsx";
import type { ReactElement } from "react";

interface Props {
  name: string;
  dir: "asc" | "desc";
  isActive: boolean;
  onClick: () => void;
}

export function TradingSortByDialogField(props: Props): ReactElement {
  const { name, dir, isActive, onClick } = props;

  return (
    <button
      className="w-full py-4 flex items-center justify-between"
      type="button"
      onClick={onClick}
    >
      <span className="flex items-center">
        <span>{name}</span>
        {isActive && (
          <ArrowLongDownIcon
            width={20}
            height={20}
            className={clsx("text-zinc-400", dir === "asc" && "rotate-180")}
          />
        )}
      </span>
      {isActive && (
        <CheckCircleIcon width={20} height={20} className="text-[#97FF29]" />
      )}
    </button>
  );
}
